import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_COURSEOUTLINEREGISTRATION,
  GET_COURSEOUTLINEREGISTRATIONS,
  GET_COURSEOUTLINEREGISTRATIONS_BY_FILTER,
  GET_COURSEOUTLINEREGISTRATIONS_BY_FILTER_FOR_TABLE,
  GET_COURSEOUTLINEREGISTRATIONS_BY_FILTER_ONLY_COURSEOUTLINE,
  ADD_COURSEOUTLINEREGISTRATION,
  UPDATE_COURSEOUTLINEREGISTRATION,
  UPDATE_TEACHER_COURSEOUTLINEREGISTRATION,
  DELETE_COURSEOUTLINEREGISTRATION
} from '@/queries/modules/courses/course-outline-registration.js';

export async function getCourseOutlineRegistrations(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINEREGISTRATIONS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.courseOutlineRegistration;
    } else {
      context.commit('setCourseOutlineRegistrations', data.getCourseOutlineRegistrations);
      context.commit('setSuccess', null);
      return data.getCourseOutlineRegistrations
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getCourseOutlineRegistrationsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINEREGISTRATIONS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setCourseOutlineRegistrations', data.getCourseOutlineRegistrationsByFilter);
      context.commit('setSuccess', null);

      return data.getCourseOutlineRegistrationsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getCourseOutlineRegistrationsByFilterForTable(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINEREGISTRATIONS_BY_FILTER_FOR_TABLE,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setCourseOutlineRegistrations', data.getCourseOutlineRegistrationsByFilter);
      context.commit('setSuccess', null);

      return data.getCourseOutlineRegistrationsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getCourseOutlineRegistrationsByFilterOnlyCourseOutline(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINEREGISTRATIONS_BY_FILTER_ONLY_COURSEOUTLINE,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setCourseOutlineRegistrations', data.getCourseOutlineRegistrationsByFilter);
      context.commit('setSuccess', null);

      return data.getCourseOutlineRegistrationsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getCourseOutlineRegistration(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINEREGISTRATION,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.courseOutlineRegistration;
    } else {
      context.commit('setCourseOutlineRegistration', data.getCourseOutlineRegistration);
      context.commit('setSuccess', null);
      return data.getCourseOutlineRegistration
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

/**
 *  Action to Add Course Outline Registration
 *
 *   @param  {Object} context Vuex context object.
 *     @property {Vuex method (Function)} commit : "To commit a mutation"
 *
 *   @param  {Object} payload Contain requires inputs for adding data
 *     @property {CourseOutlineRegistrationInput (Array), required} courseOutlineRegistrationInput : [{
          academicPeriodId: "", // {String} Get it from filter selection.
          periodCode: "",       // {String} Get it from filter selection.
          degreeId: "",         // {String} Get it from filter selection.
          subjectGroupId: "",   // {String} Get it from filter selection.
          subjectId: "",        // {String} Get it from Course Outline Selection.
          subjectCode: "",      // {String} "----------------------------------"
          subjectName: "",      // {String} "----------------------------------"
          courseOutlineId: "",  // {String} "----------------------------------"
          teacherId: "",        // {String} "----------------------------------"
          teacherCode: "",      // {String} "----------------------------------"
        }]
 *   @param  {Boolean} useState boolean if true method will set state will return data, Default: true
 *
 */
export async function addCourseOutlineRegistration(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_COURSEOUTLINEREGISTRATION,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const courseOutlineRegistrations = [...context.state.courseOutlineRegistrations];
      courseOutlineRegistrations.push(data.addCourseOutlineRegistration);
      context.commit('setCourseOutlineRegistrations', courseOutlineRegistrations);
      context.commit('setSuccess', newItemSuccess(data.addCourseOutlineRegistration.enrollNo));

      return data.addCourseOutlineRegistration
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateCourseOutlineRegistration(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_COURSEOUTLINEREGISTRATION,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.courseOutlineRegistrations.findIndex(item => item.id === data.updateCourseOutlineRegistration.id);
      const courseOutlineRegistrations = [
        ...context.state.courseOutlineRegistrations.slice(0, index),
        data.updateCourseOutlineRegistration,
        ...context.state.courseOutlineRegistrations.slice(index + 1)
      ];
      context.commit('setCourseOutlineRegistrations', courseOutlineRegistrations);
      context.commit('setSuccess', updateItemSuccess(data.updateCourseOutlineRegistration.enrollNo));

      return data.updateCourseOutlineRegistration
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateTeacherCourseOutlineRegistration(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_TEACHER_COURSEOUTLINEREGISTRATION,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.courseOutlineRegistrations.findIndex(item => item.id === data.updateTeacherCourseOutlineRegistration.id);
      const courseOutlineRegistrations = [
        ...context.state.courseOutlineRegistrations.slice(0, index),
        data.updateTeacherCourseOutlineRegistration,
        ...context.state.courseOutlineRegistrations.slice(index + 1)
      ];
      context.commit('setCourseOutlineRegistrations', courseOutlineRegistrations);
      context.commit('setSuccess', updateItemSuccess(data.updateTeacherCourseOutlineRegistration.enrollNo));

      return data.updateTeacherCourseOutlineRegistration
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

/**
 *  Action to Delete Course Outline Registration
 *
 *   @param  {Object} context Vuex context object.
 *     @property {Vuex method (Function)} commit : "To commit a mutation"
 *
 *   @param  {Object} payload Contain requires inputs for adding data
 *     @property {ID (String), required} id : "ID of a Course Outline Registration"
 *
 */
export async function deleteCourseOutlineRegistration(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_COURSEOUTLINEREGISTRATION,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.courseOutlineRegistrations.findIndex(item => item.id === data.deleteCourseOutlineRegistration.id);
      const courseOutlineRegistrations = [
        ...context.state.courseOutlineRegistrations.slice(0, index),
        ...context.state.courseOutlineRegistrations.slice(index + 1)
      ];
      context.commit('setCourseOutlineRegistrations', courseOutlineRegistrations);
      context.commit('setSuccess', deleteItemSuccess(data.deleteCourseOutlineRegistration.enrollNo));

      return data.deleteCourseOutlineRegistration
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

